export const getDomesticCleaningType = cleaningTypesList => {
  let responseObj = {};
  cleaningTypesList.forEach(
    cleaningTypeObj =>
      (responseObj[cleaningTypeObj.value] = cleaningTypeObj.label)
  );
  return responseObj;
};
